import * as React from 'react';
import { Label } from '@cian/ui-kit';
import { ILabelSchema } from '../../repositories/newbuilding-card/entities/reviews/LabelSchema';

export interface IReviewLabelsProps {
  labels: ILabelSchema[];
}

export const ReviewLabels: React.FC<IReviewLabelsProps> = ({ labels }) => {
  return <Label background={labels[0].color}>{labels[0].text}</Label>;
};
